import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'components/styles';
import useTranslation from 'next-translate/useTranslation';

export default function OrderAdjustmentSection() {
  const { t } = useTranslation();
  return (
    <>
      <HalfContainer>
        <Input
          name="approvalable.order"
          label={t('common:order')}
          type="text"
        />
      </HalfContainer>

      <FullContainer>
        <SectionContainer>
          <HalfContainer>
            <Input
              name="approvalable.description"
              label={t('common:description')}
              type="text"
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              name="approvalable.amount"
              label={t('common:adjustment')}
              type="number"
            />
          </HalfContainer>
        </SectionContainer>
      </FullContainer>
    </>
  );
}
